import React from 'react'
import {AiFillCloseCircle} from 'react-icons/ai'

const TagListItem = ({tag,removeTagHandler}) => {
    return (
        <div 
            className='flex cursor-default items-center gap-1 rounded-full bg-[#251658]/10 px-2 py-1 text-[#251658]'>
            <span>{tag}</span>
            <AiFillCloseCircle onClick={()=>removeTagHandler(tag)}/>
        </div>
    )
}

export default TagListItem
